import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'
import CommentModel from '@/views/Project/Comment/models/comment'
import UserModel from '@/views/User/models/user'
export type reactionsType =
    | 'thumbsUp'
    | 'thumbsDown'
    | 'smile'
    | 'laugh'
    | 'sad'
    | 'angry'
    | 'heart'

export const reactionsAll = {
    thumbsUp: '👍',
    thumbsDown: '👎',
    smile: '😊',
    laugh: '😂',
    sad: '😢',
    angry: '😡',
    heart: '❤️',
}
export default class ReactionModel extends JsonApiObject {
    public constructor(data: any, included?) {
        super(data, included)
    }

    reaction
    canDelete

    get comment(): CommentModel {
        return this._relationships['comment'] ? this._relationships['comment'] : null
    }

    get user(): UserModel {
        return this._relationships['user'] ? this._relationships['user'] : null
    }

    static async post(commentId, reaction: reactionsType, include = ['user']) {
        let query = {
            include: include,
            body: {
                data: {
                    type: 'reaction',
                    attributes: {
                        reaction: reaction,
                    },
                    relationships: {
                        comment: {
                            data: {
                                id: commentId,
                                type: 'comment',
                            },
                        },
                    },
                },
            },
        }
        let res = await Vue.prototype.$vbit.post('comment', `reactions`, query)
        return new ReactionModel(res.data, res.included)
    }

    async delete() {
        return await Vue.prototype.$vbit.delete('comment', `reactions/${this._id}`)
    }
}
